import type { Patient, Recipient } from "src/types";

export function isRecipientSameAsPatient(recipient: Recipient): boolean {
    return !!recipient.sameAsPatientId?.trim();
}

export function getSameAsPatient(recipient: Recipient): Patient | undefined {
    const id = recipient.sameAsPatientId?.trim();
    if (!id) return undefined;
    return recipient.patients?.find((p) => p.id === id);
}
